import { render, staticRenderFns } from "./WalletConnectButton.vue?vue&type=template&id=03132c0b&scoped=true&"
import script from "./WalletConnectButton.vue?vue&type=script&lang=js&"
export * from "./WalletConnectButton.vue?vue&type=script&lang=js&"
import style0 from "./WalletConnectButton.vue?vue&type=style&index=0&id=03132c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03132c0b",
  null
  
)

export default component.exports